<template>
  <div>
    <div class="flex_end" style="margin-bottom:30px">
      <span
        :style="$dynamicColor($store.state.readyState)"
        style="margin-right:10px"
        >{{ $store.state.readyState }}</span
      >

      <el-button
        type="other"
        :style="
          $store.state.skreadyState
            ? 'background:#FA675C'
            : $store.state.readyState !== '已连接'
            ? 'background:#42B983'
            : 'background:#436BFF'
        "
        @click="takeTitlestart(!$store.state.skreadyState)"
        >{{
          $store.state.skreadyState
            ? "关闭扫描"
            : $store.state.readyState !== "已连接"
            ? "开启连接"
            : "开始扫描"
        }}</el-button
      >
      <el-button
        type="submit"
        v-show="$store.state.readyState == '已连接'"
        @click="$store.commit('WEBSOCKET_CLEAR')"
        >清空缓存</el-button
      >
      <el-popover
        placement="bottom-start"
        width="200"
        @hide="popoverHide(rfidPower)"
        trigger="click"
        :close-delay="500"
      >
        <el-tooltip
          class="item"
          effect="dark"
          content="当前发射功率,支持输入"
          placement="left"
        >
          <el-input-number
            size="small"
            style="width: 100%"
            v-model.number="rfidPower"
            :min="1"
            :max="26"
            label="发射功率"
          ></el-input-number>
        </el-tooltip>

        <el-button style="margin-left:10px" type="submit" slot="reference"
          >调整功率</el-button
        >
      </el-popover>
    </div>
    <el-form
      class="elFormClass"
      :model="formParams"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <div class="">
        <el-form-item
          v-for="item in formItem"
          :key="item.model"
          :label="item.label"
          :prop="item.model"
          :rules="item.rules ? { required: false } : formRules.requiredChange"
        >
          <el-input
            style="flex:1"
            :disabled="
              item.model == 'staffName' || item.model == 'jobNumber'
                ? true
                : false
            "
            clearable
            v-model="formParams[item.model]"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="dialog_bottom" style="margin-top:20px">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
import { verification, numFulter, modelFulter } from "@/utils/socketFulter";

export default {
  beforeDestroy() {
    this.$store.commit("WEBSOCKET_RFIDOFF");
  },
  props: {
    callBack: Function,
    index: [String, Number],
    epc: String,
    epcList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      rfidPower: 26,
      formParams: {},
      formItem: [
        {
          label: "EPC",
          model: "epc",
          rules: true,
        },
      ],
    };
  },
  watch: {
    "$store.state.resoveMsg"(newval, oldval) {
      if (newval && !this.formParams.epc) {
        if (this.epcList.length) {
          let flag = true;
          for (let i = 0; i < this.epcList.length; i++) {
            if (this.epcList[i] == newval.substr(6)) {
              flag = false;
              break;
            }
          }
          if (flag) {
            this.$set(this.formParams, "epc", newval.substr(6));
            this.$store.commit("WEBSOCKET_RFIDOFF");
          }else{
            return
          }
        } else {
          this.$set(this.formParams, "epc", newval.substr(6));
          this.$store.commit("WEBSOCKET_RFIDOFF");
        }
      }
    },
  },
  mounted() {},
  methods: {
    popoverHide(data) {
      if (this.rfidPower !== window.localStorage.getItem("zichan_power")) {
        this.$store.commit("send", {
          data:
            "16DF04020192" +
            numFulter(data) +
            "00" +
            verification("16DF04010292" + numFulter(data) + "00"),
          code: 3,
        });
        window.localStorage.setItem("zichan_power", data);
      }
    },
    submit() {
      this.$formValidate(this, "ruleForm")
        .then(() => {
          this.callBack(this.formParams.epc, this.index);
          this.closeDialog();
        })
        .catch(() => {});
    },
    takeTitlestart(boolean) {
      if (this.$store.state.readyState !== "已连接" && boolean) {
        this.$store.commit("createSocket");
      } else {
        if (!boolean) {
          this.$store.commit("WEBSOCKET_RFIDOFF");
          return;
        }
        if (this.formParams.epc) {
          this.$success("开启失败:请清空EPC", "error");

          return;
        } else {
          this.$alertMsg.confirm(
            `确定${boolean ? "开始扫描" : "停止扫描"}吗？`,
            () => {
              this.$store.commit(
                "send",
                boolean
                  ? {
                      data: "16DF040201340030",
                      code: 3,
                    }
                  : {
                      data: "16DF040201350031",
                      code: 3,
                    }
              );
            }
          );
        }
      }
    },
    init() {
      this.$set(this.formParams, "epc", this.epc || "");
      this.rfidPower = window.localStorage.getItem("zichan_power");
      setTimeout(() => {
        this.$store.commit("WEBSOCKET_CLEAR");
        this.$store.commit("send", {
          data: "16DF040201340030",
          code: 3,
        });
      });
    },
  },
};
</script>
<style scoped></style>
